import { initializeMetrics } from '@shared_utils/metric_utils'

import { LOAD_SAT_ANTENNAS, UPDATE_SAT_ANTENNAS } from '../actions'

const initialState = initializeMetrics([])

// @TODO fix types
export default function init (previousState = initialState, { type, payload }: { type: string; payload: unknown }) {
  if (type === LOAD_SAT_ANTENNAS || type === UPDATE_SAT_ANTENNAS) {
    console.log('init sat antennas', payload)
    return Object.assign({}, previousState, payload)
  } else {
    return previousState
  }
}
